import { Box, Divider, Grid, IconButton, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import dayjs from "dayjs";
import {
  MdDiversity3,
  MdPerson,
  MdLayers,
  MdHeight,
  MdGroup,
  MdWorkHistory,
  MdGroupOff,
  MdGroupAdd,
} from "react-icons/md";
import {
  BsReception1,
  BsReception2,
  BsReception3,
  BsReception4,
  BsDiagram3Fill,
  BsFillPersonVcardFill,
  Bs1CircleFill,
  Bs2CircleFill,
  Bs3CircleFill,
  Bs4CircleFill,
  Bs5CircleFill,
  Bs6CircleFill,
  Bs7CircleFill,
  Bs8CircleFill,
  Bs9CircleFill,
  BsExclamationTriangleFill,
  BsCheckCircleFill,
  BsXCircleFill,
  BsInfoCircleFill,
} from "react-icons/bs";
import styled from "@emotion/styled";

const styles = {
  card: {
    position: "absolute",
    // top: "17.5%",
    top: "16.5%",
    left: "1.2rem",
    width: "20%",
    // height: "80%",
    height: "70%",
    // margin: "0.5rem 0px 0px 1rem",
    margin: "0.5rem 0px 0px 0px",
    backgroundColor: "#ffffff",
    borderRadius: "1rem",
    border: "2px solid #00449e",
    overflowY: "auto",
    // scrollbarWidth: "thin",
    // scrollbarGutter: "both-edges",
    scrollbarWidth: "none",
  },
  cardHeader: {
    display: "flex",
    alignItems: "start",
    width: "calc(100% - 1rem)",
    minHeight: "2rem",
    justifyContent: "space-between",
    marginLeft: "1rem",
    position: "sticky",
  },
  closeBtn: {
    padding: "0.25rem",
    backgroundColor: "#ffffff",
    cursor: "pointer",
    borderRadius: "100%",
    color: "#00449e",
    "&:hover": {
      backgroundColor: "#eaf1fb",
    },
    "&:focus:not(:hover)": {
      backgroundColor: "#ffffff",
      boxShadow: "none",
    },
  },
  cardContent: {
    margin: "0px 1rem 0.25rem 1rem",
    color: "#6691c4",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
  },
  cardName: {
    paddingBottom: "0.3rem",
    fontSize: "20px",
    fontWeight: "bold",
    color: "#00449e",
  },
  infoText: {
    color: "#6691c4",
    fontWeight: "normal",
    fontSize: "14px",
    marginLeft: "0.5rem",
  },
  statsTitleText: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    color: "#6691c4",
    //color: "#42527d",
    fontWeight: "bold",
    marginTop: "0.25rem",
    // marginLeft: "1rem",
    fontSize: "14px",
  },
  gridContainer: {
    fontSize: "14px",
    width: "100%",
    marginTop: "0.5rem",
    marginLeft: "0.5rem",
    justifyContent: "start",
    columnGap: "0.5rem",
    color: "#6691c4",
    flexDirection: "column",
  },
  gridElement: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    // width: "calc(100% / 2 - 0.5rem)"
    width: "calc(100% - 0.5rem)",
  },
  reportsGridElement: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    // width: "calc(100% / 3 - 0.5rem)"
    width: "calc(100% - 0.5rem)",
  },
  levelsGridElement: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    // width: "calc(100% / 4 - 0.5rem)"
    width: "calc(100% - 0.5rem)",
  },
  layerText: {
    color: "#6691c4",
    fontWeight: "normal",
    fontSize: "14px",
    // marginLeft: "0.5rem",
  },
  cardSectionTitle: {
    textAlign: "start",
    fontWeight: "bold",
    fontSize: "16px",
  },
  cardSectionContainer: {
    display: "flex",
    justifyContent: "space-between",
    columnGap: "0.5rem",
  },
  sectionColumnContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    width: "calc(50% - 0.25rem)",
  },
};

const Lvl1Icon = styled(BsReception1)`
  transform: rotate(-90deg) scale(1.2);
`;

const Person = styled(MdPerson)`
  transform: scale(1.2);
`;

const FemaleQuota = styled(MdGroup)`
  transform: scale(1.2);
  color: #c46691;
`;

const OkCheck = styled(BsCheckCircleFill)`
  transform: scale(1.2);
  color: #317b22;
`;

const Warn = styled(BsExclamationTriangleFill)`
  transform: scale(1.2);
  color: #de9502;
`;

const Error = styled(BsXCircleFill)`
  transform: scale(1.2);
  color: #ea3546;
`;

const Lvl2Icon = Lvl1Icon.withComponent(BsReception2);
const Lvl3Icon = Lvl1Icon.withComponent(BsReception3);
const Lvl4Icon = Lvl1Icon.withComponent(BsReception4);
const SpanIcon = Lvl1Icon.withComponent(MdHeight);

const ChartIcon = Person.withComponent(BsDiagram3Fill);
const PeopleGroup = Person.withComponent(MdDiversity3);
const MaleQuota = Person.withComponent(MdGroup);
const Tenure = Person.withComponent(MdWorkHistory);
const Age = Person.withComponent(BsFillPersonVcardFill);
const Layers = Person.withComponent(MdLayers);
const Circle1 = Person.withComponent(Bs1CircleFill);
const Circle2 = Person.withComponent(Bs2CircleFill);
const Circle3 = Person.withComponent(Bs3CircleFill);
const Circle4 = Person.withComponent(Bs4CircleFill);
const Circle5 = Person.withComponent(Bs5CircleFill);
const Circle6 = Person.withComponent(Bs6CircleFill);
const Circle7 = Person.withComponent(Bs7CircleFill);
const Circle8 = Person.withComponent(Bs8CircleFill);
const Circle9 = Person.withComponent(Bs9CircleFill);
const NoTeam = Person.withComponent(MdGroupOff);
const LargeTeam = Person.withComponent(MdGroupAdd);
const Info = Person.withComponent(BsInfoCircleFill);

const EmployeeDetailsCard = (props) => {
  const [sectionToRender, setSectionToRender] = useState({});

  useEffect(() => {
    const reportsRenderConf = [
      {
        key: "totalReports",
        icon: ChartIcon,
        value: "0",
        tooltip: "Reports number",
        uom: "",
        show: true,
      },
      {
        key: "peopleManager",
        icon: PeopleGroup,
        value: "0",
        tooltip: "Managers of people",
        uom: "",
        show: true,
      },
      {
        key: "individualContribuitors",
        icon: Person,
        value: "0",
        tooltip: "Non manager",
        uom: "",
        show: true,
      },
    ];

    const managerialLvlRenderConf = [
      {
        key: "executive",
        icon: Lvl4Icon,
        value: "0",
        perc: "0",
        tooltip: "Top Manager",
        uom: "",
        show: true,
      },
      {
        key: "managerOfManagers",
        icon: Lvl3Icon,
        value: "0",
        perc: "0",
        tooltip: "Manager of managers",
        uom: "",
        show: true,
      },
      {
        key: "managerOfIndividuals",
        icon: Lvl2Icon,
        value: "0",
        perc: "0",
        tooltip: "Manager of individuals",
        uom: "",
        show: true,
      },
      {
        key: "individualContribuitors",
        icon: Lvl1Icon,
        value: "0",
        perc: "0",
        tooltip: "Individual contribuitors",
        uom: "",
        show: true,
      },
    ];

    const directAnalyticsRenderConf = [
      {
        key: "layers",
        icon: Layers,
        value: "0",
        tooltip: "Layers",
        uom: "",
        show: false,
      },
      {
        key: "span",
        icon: SpanIcon,
        value: "0",
        tooltip: "Span",
        uom: "",
        show: false,
      },
      {
        key: "maleQuota",
        icon: MaleQuota,
        value: "0",
        tooltip: "Male Quota",
        uom: "%",
        show: true,
      },
      {
        key: "femaleQuota",
        icon: FemaleQuota,
        value: "0",
        tooltip: "Female Quota",
        uom: "%",
        show: true,
      },
      {
        key: "age",
        icon: Age,
        value: "0",
        tooltip: "Average age",
        uom: "",
        show: true,
      },
      {
        key: "seniority",
        icon: Tenure,
        value: "0",
        tooltip: "Average seniority",
        uom: "",
        show: true,
      },
    ];

    const indirectAnalyticsRenderConf = [
      {
        key: "layers",
        icon: Layers,
        value: "0",
        tooltip: "",
        uom: "",
        show: false,
      },
      {
        key: "span",
        icon: SpanIcon,
        value: "0",
        tooltip: "Average span of direct reports",
        uom: "",
        show: false,
      },
      {
        key: "maleQuota",
        icon: MaleQuota,
        value: "0",
        tooltip: "Male Quota",
        uom: "%",
        show: true,
      },
      {
        key: "femaleQuota",
        icon: FemaleQuota,
        value: "0",
        tooltip: "Female Quota",
        uom: "%",
        show: true,
      },
      {
        key: "age",
        icon: Age,
        value: "0",
        tooltip: "Average age",
        uom: "",
        show: true,
      },
      {
        key: "seniority",
        icon: Tenure,
        value: "0",
        tooltip: "Average seniority",
        uom: "",
        show: true,
      },
    ];

    let layerData = [
      { layer: "1", icon: Circle1, value: "0", perc: "0", show: false },
      { layer: "2", icon: Circle2, value: "0", perc: "0", show: false },
      { layer: "3", icon: Circle3, value: "0", perc: "0", show: false },
      { layer: "4", icon: Circle4, value: "0", perc: "0", show: false },
      { layer: "5", icon: Circle5, value: "0", perc: "0", show: false },
      { layer: "6", icon: Circle6, value: "0", perc: "0", show: false },
      { layer: "7", icon: Circle7, value: "0", perc: "0", show: false },
      { layer: "8", icon: Circle8, value: "0", perc: "0", show: false },
      { layer: "9", icon: Circle9, value: "0", perc: "0", show: false },
    ];

    // min and max properties used for size check: greater or equal to min, less than max;
    const teamSizes = [
      {
        key: "noTeam",
        min: 0,
        max: 1,
        count: 0,
        perc: 0,
        show: true,
        tooltip: "No team",
        icon: NoTeam,
      },
      {
        key: "1to1",
        min: 1,
        max: 2,
        count: 0,
        perc: 0,
        show: true,
        tooltip: "1 to 1 manager",
        icon: Person,
      },
      {
        key: "micro",
        min: 2,
        max: 4,
        count: 0,
        perc: 0,
        show: true,
        tooltip: "Micro Team",
        icon: PeopleGroup,
      },
      // {key: "small", min: 4, max: 8, count: 0, perc: 0, show: true, tooltip: "4 to 7", icon: MaleQuota},
      // {key: "medium", min: 8, max: 12, count: 0, perc: 0, show: true, tooltip: "8 to 12", icon: PeopleGroup},
      {
        key: "large",
        min: 4,
        max: Infinity,
        count: 0,
        perc: 0,
        show: false,
        tooltip: "12+",
        icon: LargeTeam,
      },
    ];

    const thresholdsConfig = {
      span: [
        {
          key: "nullValueSpan",
          min: 0,
          max: 0,
          message: "Impossible to check the span score",
          icon: Info,
        },
        {
          key: "errorLowSpan",
          min: 0,
          max: 0.6,
          message: "Attention: Span is too low",
          icon: Error,
        },
        {
          key: "warnLowSpan",
          min: 0.6,
          max: 0.8,
          message: "Warning: Span is low",
          icon: Warn,
        },
        {
          key: "goodValueSpan",
          min: 0.8,
          max: 1.2,
          message: "Span is ideal",
          icon: OkCheck,
        },
        {
          key: "warnOverSpan",
          min: 1.2,
          max: 1.5,
          message: "Warning: Span is high",
          icon: Warn,
        },
        {
          key: "errorOverSpan",
          min: 1.5,
          max: Infinity,
          message: "Attention: Span is too high",
          icon: Error,
        },
      ],
      layers: [
        {
          key: "nullValueLayer",
          message: "Impossible to check the number of layers",
          icon: Info,
        },
        {
          key: "okLayer",
          message: "Number of layers: OK",
          icon: OkCheck,
        },
        {
          key: "overLayer",
          message: "Number of layers: Over the guidelines",
          icon: Error,
        },
      ],
    };

    const roundNum = (num, decimals) => {
      return Math.round(num * 10 ** decimals) / 10 ** decimals;
    };

    // Calculate years worked for the company or age for one worker
    const calculateYears = (worker, dateColumn) => {
      const columnDate = worker[dateColumn];
      const columnDateObj =
        columnDate !== undefined && columnDate !== null
          ? dayjs(columnDate, "YYYY-MM-DD")
          : null;
      const now = dayjs();
      let age = undefined;
      if (columnDateObj) {
        age = now.year() - columnDateObj.year();
        const m = now.month() - columnDateObj.month();
        age =
          m < 0 || (m === 0 && now.date() < columnDateObj.date())
            ? age - 1
            : age;
      }

      return age;
    };

    // Average years worked for the company or average Age
    const calculateAvgYears = (reports, column) => {
      const ageList = reports
        .map((worker) => calculateYears(worker, column))
        .filter((age) => !isNaN(age));
      const ageSum = ageList.reduce((acc, curr) => acc + curr, 0);
      const ageAvg = roundNum(ageSum / ageList.length, 1);

      return ageAvg.toString();
    };

    // Average number of years worked for the company
    const calculateGenderQuotas = (reports) => {
      const reportsNumber = reports.length;
      const femaleReportsNumber = reports.filter(
        (p) => p.gender === "F"
      ).length;
      const femalePercentage = (femaleReportsNumber / reportsNumber) * 100;
      const femalePercentageRounded = roundNum(femalePercentage, 1);
      const malePercentage = roundNum(100 - femalePercentageRounded, 1);

      return {
        male: malePercentage.toString(),
        female: femalePercentageRounded.toString(),
      };
    };

    const calculateLayers = (employee, indirectReports) => {
      const baseLvl = employee.ceo_h_level;
      const lowestLvl = Math.max(...indirectReports.map((p) => p.ceo_h_level));
      const layersNum = lowestLvl - baseLvl;
      return { dept: layersNum.toString() };
    };

    const calculateSpan = (orgData, directReports) => {
      const baseSpan = directReports.length;
      let directReportsSpan = 0;
      for (const direct of directReports) {
        const directSpan = orgData.filter(
          (node) => node.parentId === direct.id
        ).length;
        directReportsSpan += directSpan;
      }

      const avgSpan = directReportsSpan / baseSpan;
      const roundedAvgSpan = roundNum(avgSpan, 1);
      return { base: baseSpan.toString(), avg: roundedAvgSpan.toString() };
    };

    const evaluateSpanLayerThresholds = (employee) => {
      const layersExeceeded = employee.exceeds_layer_limit;
      const spanScore = parseFloat(employee.span_score) || null;
      const layersBelow = parseFloat(employee.layers_below) || null;
      const spanMaxLimit = parseFloat(employee.span_max_limit) || null;
      // console.log("employee", employee);
      // console.log("Span Max Limit", spanMaxLimit);

      let spanLayerThreshold = [];
      let spanThreshold = {};
      //  Span threshold evaluation
      if (
        spanScore &&
        !isNaN(spanScore) &&
        !isNaN(layersBelow) &&
        !isNaN(spanMaxLimit)
      ) {
        const upperLimit = layersBelow === 1 ? spanMaxLimit : Math.min(layersBelow * 3, spanMaxLimit);
        const lowerLimit = 
          layersBelow === 1 
            ? 1 
            : layersBelow === 2 
              ? 2 
              : Math.floor(0.8 * layersBelow);
        let secondaryMessage = `Actual Span: ${spanScore.toString()}. Ideal Range: ${layersBelow} - ${upperLimit}`;
        if (spanScore >= layersBelow && spanScore <= upperLimit) {
          spanThreshold = thresholdsConfig.span.find(
            (c) => c.key === "goodValueSpan"
          );
          secondaryMessage = "";
        } else if (spanScore > upperLimit && spanScore <= spanMaxLimit) {
          spanThreshold = thresholdsConfig.span.find(
            (c) => c.key === "warnOverSpan"
          );
        } else if (spanScore >= lowerLimit && spanScore < layersBelow) {
          spanThreshold = thresholdsConfig.span.find(
            (c) => c.key === "warnLowSpan"
          );
        } else if (spanScore > spanMaxLimit) {
          spanThreshold = thresholdsConfig.span.find(
            (c) => c.key === "errorOverSpan"
          );
        } else if (spanScore < lowerLimit) {
          spanThreshold = thresholdsConfig.span.find(
            (c) => c.key === "errorLowSpan"
          );
        } else {
          spanThreshold = thresholdsConfig.span.find(
            (c) => c.key === "nullValueSpan"
          );
          secondaryMessage = "";
        }
        spanLayerThreshold.push({
          ...spanThreshold,
          value: spanScore,
          upperLimit: upperLimit,
          lowerLimit: lowerLimit,
          secondaryMessage: secondaryMessage,
        });
        console.log("spanLayerThreshold: ", spanLayerThreshold);

      } else {
        const nullSpanValue = thresholdsConfig.span.find(
          (c) => c.key === "nullValueSpan"
        );
        spanLayerThreshold.push({
          ...nullSpanValue,
          value: spanScore,
          secondaryMessage: "",
        });
      }

      // Layers threshold evaluation
      let layerNumberStatus = {};

      if (!layersExeceeded && layersExeceeded !== null) {
        layerNumberStatus = thresholdsConfig.layers.find(
          (c) => c.key === "okLayer"
        );
      } else if (layersExeceeded) {
        layerNumberStatus = thresholdsConfig.layers.find(
          (c) => c.key === "overLayer"
        );
      } else {
        layerNumberStatus = thresholdsConfig.layers.find(
          (c) => c.key === "nullValueLayer"
        );
      }
      spanLayerThreshold.push({
        ...layerNumberStatus,
        value: layerNumberStatus,
        secondaryMessage: "",
      });

      return spanLayerThreshold;
    };

    // const getIndirectReports = (orgData, id) => {
    //   let result = [];

    //   const getLevelBelow = (id) => {
    //     const children = orgData.filter((node) => node.parentId === id);
    //     for (const child of children) {
    //       result.push(child);
    //       getLevelBelow(child.id);
    //     }
    //   };

    //   getLevelBelow(id);
    //   return result;
    // };

    const getIndirectReports = (orgData, id) => {
      // Build parent-to-children lookup map once (O(n))
      const childrenMap = new Map();

      for (const node of orgData) {
        if (node.parentId) {
          if (!childrenMap.has(node.parentId)) {
            childrenMap.set(node.parentId, []);
          }
          childrenMap.get(node.parentId).push(node);
        }
      }

      // Use iterative traversal instead of recursion (O(k) where k = descendants)
      const result = [];
      const queue = [id];

      while (queue.length > 0) {
        const currentId = queue.shift();
        const children = childrenMap.get(currentId) || [];

        for (const child of children) {
          result.push(child);
          queue.push(child.id);
        }
      }

      return result;
    };

    const calculateManagerialLevel = (groupedReports, totalReports) => {
      let managerialLvlCount = {
        individualContribuitors: "0",
        executive: "0",
        managerOfIndividuals: "0",
        managerOfManagers: "0",
        totalReports: totalReports,
        // peopleManager: "0",
      };

      const absoluteLvlKeys = Object.keys(groupedReports).map((k) =>
        parseInt(k)
      );
      const lowestLvl = Math.max(...absoluteLvlKeys);
      const highestLvl = Math.min(...absoluteLvlKeys);
      let lvlIndividual = [];
      let lvlExecutive = [];
      let lvlMoI = [];
      let lvlMoM = [];

      for (let i = lowestLvl; i >= highestLvl; i--) {
        if (absoluteLvlKeys.indexOf(i) > -1) {
          if (i <= 1) {
            lvlExecutive = lvlExecutive.concat(groupedReports[i.toString()]);
          } else {
            if (i === lowestLvl) {
              lvlIndividual = lvlIndividual.concat(
                groupedReports[i.toString()]
              );
            } else {
              for (let worker of groupedReports[i.toString()]) {
                const reportsIndividualsNum = lvlIndividual.filter(
                  (w) => w.parentId === worker.id
                ).length;
                const reportsMoINum =
                  lvlMoI.length > 0
                    ? lvlMoI.filter((w) => w.parentId === worker.id).length
                    : 0;
                const reportsMoMNum =
                  lvlMoM.length > 0
                    ? lvlMoM.filter((w) => w.parentId === worker.id).length
                    : 0;
                reportsMoMNum !== 0
                  ? (lvlMoM = lvlMoM.concat(worker))
                  : reportsMoINum !== 0
                  ? (lvlMoM = lvlMoM.concat(worker))
                  : reportsIndividualsNum === 0
                  ? (lvlIndividual = lvlIndividual.concat(worker))
                  : (lvlMoI = lvlMoI.concat(worker));
              }
            }
          }
        } else {
          const msg = "Level " + i.toString() + " not found!";
          console.log(msg);
        }
      }

      const managerialLvl = {
        individualContribuitors: lvlIndividual,
        executive: lvlExecutive,
        managerOfIndividuals: lvlMoI,
        managerOfManagers: lvlMoM,
      };

      for (let key in managerialLvl) {
        managerialLvlCount[key] = managerialLvl[key].length;
      }

      managerialLvlCount["peopleManager"] =
        managerialLvlCount.totalReports -
        managerialLvlCount.individualContribuitors;
      return { counts: managerialLvlCount, lists: managerialLvl };
    };

    const analyseLayers = (groupedReports, totalReports) => {
      let newLayerData = [];
      for (let lvl in groupedReports) {
        const lvlCount = groupedReports[lvl].length;
        const lvlPerc = roundNum((lvlCount / totalReports) * 100, 1);
        const layerConfIdx = layerData.findIndex((l) => l.layer === lvl);
        newLayerData.push({
          ...layerData[layerConfIdx],
          ...{ value: lvlCount, perc: lvlPerc, show: true },
        });
      }
      return newLayerData;
    };

    const analyseSpan = (employee, indirectReports) => {
      const fromSelectedWorker = [employee, ...indirectReports];
      const totalWorkers = fromSelectedWorker.length;
      const sortedIndirect = fromSelectedWorker.sort(
        (a, b) => a.ceo_h_level - b.ceo_h_level
      );
      let reportsSpanArr = [];
      let managersList = [];
      let individualsList = [];
      let spanList = [];
      for (let worker of sortedIndirect) {
        const workerReportsCount = sortedIndirect.filter(
          (w) => w.parentId === worker.id
        ).length;
        spanList.push({ name: worker.name, span: workerReportsCount });
        if (workerReportsCount !== 0) {
          reportsSpanArr.push(workerReportsCount);
          managersList.push({ name: worker.name, span: workerReportsCount });
        } else {
          individualsList.push({ name: worker.name, span: 0 });
        }
        for (let size of teamSizes) {
          if (workerReportsCount >= size.min && workerReportsCount < size.max) {
            size.count += 1;
            break;
          }
        }
      }

      for (let s of teamSizes) {
        s.perc = roundNum((s.count / totalWorkers) * 100, 1).toString();
        // s.count > 0 ? s.show = true : s.show = false;
      }

      const avg =
        reportsSpanArr.length !== 0
          ? reportsSpanArr.reduce((acc, current) => acc + current, 0) /
            reportsSpanArr.length
          : 0;
      const spanAvgRounded = !isNaN(avg) ? roundNum(avg, 2) : 0;

      return { spanList: spanList, teamsData: teamSizes };
    };

    const updateRenderConfArray = (renderArray, valuesArray) => {
      let newRenderConf = [];
      for (let renderObj of renderArray) {
        const renderKey = renderObj.key;
        const valuesObj = valuesArray.find((val) => val.key === renderKey);
        const value = valuesObj ? valuesObj.value.toString() : "";
        // const value = valuesArray.find((val) => val.key === renderKey)?.value | "";
        if (Object.hasOwn(renderObj, "perc")) {
          const perc =
            valuesObj && Object.hasOwn(valuesObj, "perc")
              ? valuesObj.perc.toString()
              : "";
          newRenderConf.push({ ...renderObj, value: value, perc: perc });
        } else {
          newRenderConf.push({ ...renderObj, value: value });
        }
      }
      return newRenderConf;
    };

    const analyseReports = (employee, orgData) => {
      let directReports = [];
      let indirectReports = [];

      if (orgData && orgData.length > 0) {
        directReports = orgData.filter((node) => node.parentId === employee.id);
        if (directReports.length > 0) {
          indirectReports = getIndirectReports(orgData, employee.id);

          const genderQuotas = {
            direct: calculateGenderQuotas(directReports),
            indirect: calculateGenderQuotas(indirectReports),
          };

          const avgAge = {
            direct: calculateAvgYears(directReports, "date_of_birth"),
            indirect: calculateAvgYears(indirectReports, "date_of_birth"),
          };

          const avgSeniority = {
            direct: calculateAvgYears(directReports, "hiring_date"),
            indirect: calculateAvgYears(indirectReports, "hiring_date"),
          };

          // const spanCalc = calculateSpan(orgData, directReports);
          // const layerCalc = calculateLayers(employee, indirectReports);

          const groupedReports = Object.groupBy(
            indirectReports,
            ({ ceo_h_level }) => ceo_h_level
          );

          layerData = analyseLayers(groupedReports, indirectReports.length);
          const managerialLvls = calculateManagerialLevel(
            groupedReports,
            indirectReports.length
          );
          const spanData = analyseSpan(employee, indirectReports);
          const spanList = spanData.spanList;
          const teamsData = spanData.teamsData;

          //let hErrors = [];
          for (let lvl in managerialLvls.lists) {
            if (lvl !== "individualContribuitors") {
              let errors = spanList
                .map((w) => {
                  const manIdx = managerialLvls["lists"][lvl].findIndex(
                    (m) => m.name === w.name
                  );
                  let err = {};
                  if (manIdx > -1) {
                    if (w.span === 0) {
                      err = {
                        ...w,
                        level: lvl,
                        h_lvl: managerialLvls["lists"][lvl][manIdx].ceo_h_level,
                      };
                    }
                  }
                  return err;
                })
                .filter((h) => Object.keys(h).length > 0);
              console.log(errors);
            }
          }
          const spanLayerEvaluation = evaluateSpanLayerThresholds(employee);
          console.log("Evaluation: ", spanLayerEvaluation);
          const directAnalysisValues = [
            // {key: "span", value: spanCalc.base},
            // {key: "layers", value: layerCalc.dept},
            { key: "maleQuota", value: genderQuotas.direct.male },
            { key: "femaleQuota", value: genderQuotas.direct.female },
            { key: "age", value: avgAge.direct },
            { key: "seniority", value: avgSeniority.direct },
          ];

          const indirectAnalysisValues = [
            // {key: "span", value: spanCalc.avg},
            // {key: "layers", value: "0"},
            { key: "maleQuota", value: genderQuotas.indirect.male },
            { key: "femaleQuota", value: genderQuotas.indirect.female },
            { key: "age", value: avgAge.indirect },
            { key: "seniority", value: avgSeniority.indirect },
          ];

          const managerialLvlCount = [];

          for (let key in managerialLvls.counts) {
            const keyCount = managerialLvls.counts[key];
            const totalReports = indirectReports.length;
            const perc = roundNum((keyCount / totalReports) * 100, 1);
            managerialLvlCount.push({ key: key, value: keyCount, perc: perc });
          }

          return {
            directAnalyticsRenderConf: updateRenderConfArray(
              directAnalyticsRenderConf,
              directAnalysisValues
            ),
            indirectAnalyticsRenderConf: updateRenderConfArray(
              indirectAnalyticsRenderConf,
              indirectAnalysisValues
            ),
            reportsRenderConf: updateRenderConfArray(
              reportsRenderConf,
              managerialLvlCount
            ),
            managerialLvlRenderConf: updateRenderConfArray(
              managerialLvlRenderConf,
              managerialLvlCount
            ),
            layerData: layerData,
            spanData: teamsData,
            spanLayerEval: spanLayerEvaluation,
          };
          // setIsCalculated(true);
        } else {
          return {};
        }
      }
    };

    props.employees.length > 0
      ? setSectionToRender(analyseReports(props.employee, props.employees))
      : setSectionToRender({});
  }, [props]);

  return (
    <div style={styles.card}>
      <div style={styles.cardHeader}>
        <Box style={styles.cardName}>
          {props.employee.name !== ", " ? props.employee.name : ""}
        </Box>
        <IconButton
          aria-label="close"
          sx={styles.closeBtn}
          onClick={props.handleClose}
        >
          <CloseRoundedIcon />
        </IconButton>
      </div>
      {Object.keys(sectionToRender).length > 0 ? (
        <div style={styles.cardContent}>
          <Box style={styles.cardSectionTitle}> Span & Layers Analysis </Box>
          <div style={styles.cardSectionContainer}>
            <div style={styles.sectionColumnContainer}>
              <Box style={styles.statsTitleText}>
                <Box> Levels </Box>
                <Grid container style={styles.gridContainer}>
                  {sectionToRender.managerialLvlRenderConf.map((item) => {
                    const IconComponent = item.icon;
                    return item.show ? (
                      <Tooltip
                        title={item.tooltip}
                        placement="top-start"
                        key={item.key}
                      >
                        <Grid size={6} style={styles.gridElement}>
                          <Grid
                            container
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "center",
                              columnGap: "0.25rem",
                            }}
                          >
                            <Grid
                              size={4}
                              style={{
                                display: "flex",
                                justifyContent: "start",
                                alignItems: "center",
                                width: "20%",
                              }}
                            >
                              <IconComponent />
                            </Grid>
                            <Grid
                              size={4}
                              style={{
                                display: "flex",
                                justifyContent: "start",
                                alignItems: "center",
                                width: "35%",
                              }}
                            >
                              <p style={styles.layerText}>{item.value} </p>
                            </Grid>
                            <Grid
                              size={4}
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                alignItems: "center",
                                width: "35%",
                              }}
                            >
                              <p style={styles.layerText}>{item.perc}% </p>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Tooltip>
                    ) : (
                      <Grid
                        size={4}
                        style={{
                          ...styles.levelsGridElement,
                          visibility: "hidden",
                        }}
                        key={item.key}
                      >
                        <IconComponent />
                        <p style={styles.infoText}>{item.value} </p>
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
              <Box style={styles.statsTitleText}>
                <Box>Span</Box>
                <Grid container style={styles.gridContainer}>
                  {sectionToRender.spanData.map((teamSize) => {
                    const IconComponent = teamSize.icon;
                    return teamSize.show === true ? (
                      <Tooltip
                        title={teamSize.tooltip}
                        placement="top-start"
                        key={teamSize.key}
                      >
                        <Grid size={6} style={styles.gridElement}>
                          <Grid
                            container
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "center",
                              columnGap: "0.25rem",
                            }}
                          >
                            <Grid
                              size={4}
                              style={{
                                display: "flex",
                                justifyContent: "start",
                                alignItems: "center",
                                width: "20%",
                              }}
                            >
                              <IconComponent />
                            </Grid>
                            <Grid
                              size={4}
                              style={{
                                display: "flex",
                                justifyContent: "start",
                                alignItems: "center",
                                width: "35%",
                              }}
                            >
                              <p style={styles.layerText}>
                                {teamSize.count.toString()}{" "}
                              </p>
                            </Grid>
                            <Grid
                              size={4}
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                alignItems: "center",
                                width: "35%",
                              }}
                            >
                              <p style={styles.layerText}>
                                {teamSize.perc.toString()}%{" "}
                              </p>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Tooltip>
                    ) : (
                      <div style={{ display: "none" }} key={teamSize.key}></div>
                    );
                  })}
                </Grid>
              </Box>
            </div>
            <Divider
              orientation="vertical"
              sx={{
                height: "auto",
                backgroundColor: "#00449e",
                margin: "0.4rem 0px 0.2rem 0px",
              }}
            />
            <div
              style={{
                ...styles.sectionColumnContainer,
                justifyContent: "start",
              }}
            >
              <Box style={styles.statsTitleText}>
                <Box>Layers</Box>
                <Grid container style={styles.gridContainer}>
                  {sectionToRender.layerData.map((layer) => {
                    const IconComponent = layer.icon;
                    return layer.show === true ? (
                      <Tooltip
                        title={"Hierarchy level " + layer.layer}
                        placement="top-start"
                        key={layer.layer}
                      >
                        <Grid size={6} style={styles.gridElement}>
                          <Grid
                            container
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "center",
                              columnGap: "0.25rem",
                            }}
                          >
                            <Grid
                              size={4}
                              style={{
                                display: "flex",
                                justifyContent: "start",
                                alignItems: "center",
                                width: "20%",
                              }}
                            >
                              <IconComponent />
                            </Grid>
                            <Grid
                              size={4}
                              style={{
                                display: "flex",
                                justifyContent: "start",
                                alignItems: "center",
                                width: "35%",
                              }}
                            >
                              <p style={styles.layerText}>{layer.value} </p>
                            </Grid>
                            <Grid
                              size={4}
                              style={{
                                display: "flex",
                                justifyContent: "end",
                                alignItems: "center",
                                width: "35%",
                              }}
                            >
                              <p style={styles.layerText}>{layer.perc}% </p>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Tooltip>
                    ) : (
                      <div style={{ display: "none" }}></div>
                    );
                  })}
                </Grid>
              </Box>
            </div>
          </div>
          <Divider
            sx={{
              width: "auto",
              backgroundColor: "#00449e",
              margin: "0.4rem 0px 0.4rem 0px",
            }}
          />
          <div style={styles.cardSectionContainer}>
            <Box
              style={{
                ...styles.statsTitleText,
                width: "calc(100% - 0.25rem)",
              }}
            >
              <Box> Span & Layer compliance analysis </Box>
              <Grid container style={styles.gridContainer}>
                {sectionToRender.spanLayerEval.map((item) => {
                  const IconComponent = item.icon;
                  return (
                    <Grid
                      container
                      style={{ ...styles.gridContainer, marginLeft: "0" }}
                    >
                      <Grid
                        size={12}
                        // style={{ ...styles.reportsGridElement, mb: "0.25rem" }}
                        style={styles.reportsGridElement}
                        key={item.key}
                      >
                        <IconComponent />
                        <p style={styles.infoText}>{item.message}</p>
                      </Grid>
                      {item.secondaryMessage && item.secondaryMessage.length > 0 && (
                        <Grid
                          size={12}
                          style={styles.reportsGridElement}
                          key={item.key + "_1"}
                        >
                          <IconComponent style={{ visibility: "hidden" }} />
                          <p style={styles.infoText}>{item.secondaryMessage}</p>
                        </Grid>
                      )}
                    </Grid>
                    // ) : (
                    //   <Grid
                    //     size={4}
                    //     style={{ ...styles.reportsGridElement, display: "none" }}
                    //     key={item.key + "-dir"}
                    //   >
                    //     <IconComponent />
                    //     <p style={styles.infoText}>{item.value} </p>
                    //   </Grid>
                  );
                })}
              </Grid>
            </Box>
          </div>
          <Divider
            sx={{
              width: "auto",
              backgroundColor: "#00449e",
              margin: "0.4rem 0px 0.4rem 0px",
            }}
          />
          <Box style={styles.cardSectionTitle}> People Analysis </Box>
          <div style={styles.cardSectionContainer}>
            <Box
              style={{ ...styles.statsTitleText, width: "calc(50% - 0.25rem)" }}
            >
              <Box> Direct</Box>
              <Grid container style={styles.gridContainer}>
                {sectionToRender.directAnalyticsRenderConf.map((item) => {
                  const IconComponent = item.icon;
                  return item.show ? (
                    <Tooltip
                      title={item.tooltip}
                      placement="top-start"
                      key={item.key + "-dir"}
                    >
                      <Grid size={4} style={styles.reportsGridElement}>
                        <IconComponent />
                        <p style={styles.infoText}>
                          {item.value}
                          {item.uom}{" "}
                        </p>
                      </Grid>
                    </Tooltip>
                  ) : (
                    <Grid
                      size={4}
                      style={{ ...styles.reportsGridElement, display: "none" }}
                      key={item.key + "-dir"}
                    >
                      <IconComponent />
                      <p style={styles.infoText}>{item.value} </p>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
            <Divider
              orientation="vertical"
              sx={{
                height: "auto",
                backgroundColor: "#00449e",
                margin: "0.4rem 0px 0.2rem 0px",
              }}
            />
            <Box
              style={{ ...styles.statsTitleText, width: "calc(50% - 0.25rem)" }}
            >
              <Box> Indirect </Box>
              <Grid container style={styles.gridContainer}>
                {sectionToRender.indirectAnalyticsRenderConf.map((item) => {
                  const IconComponent = item.icon;
                  return item.show ? (
                    <Tooltip
                      title={item.tooltip}
                      placement="top-start"
                      key={item.key + "-indir"}
                    >
                      <Grid size={6} style={styles.reportsGridElement}>
                        <IconComponent />
                        <p style={styles.infoText}>
                          {item.value}
                          {item.uom}{" "}
                        </p>
                      </Grid>
                    </Tooltip>
                  ) : (
                    <Grid
                      size={6}
                      style={{ ...styles.reportsGridElement, display: "none" }}
                      key={item.key + "-indir"}
                    >
                      <IconComponent />
                      <p style={styles.infoText}>{item.value} </p>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          </div>
        </div>
      ) : (
        <div style={styles.cardContent}>
          <Box style={styles.statsTitleText}>
            <Box> Can't run the analysis for an individual contribuitor </Box>
          </Box>
        </div>
      )}
    </div>
  );
};

export default EmployeeDetailsCard;
